import { render, staticRenderFns } from "./ForeignB2b.vue?vue&type=template&id=53454975&scoped=true"
import script from "./ForeignB2b.vue?vue&type=script&lang=js"
export * from "./ForeignB2b.vue?vue&type=script&lang=js"
import style0 from "./ForeignB2b.vue?vue&type=style&index=0&id=53454975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53454975",
  null
  
)

export default component.exports